import { i18n } from '@/localization/localization';

type TranslateFunction = (key: string) => string;

export const t: TranslateFunction = (key: string): string => {
    return i18n.global.t(key);
}; 